export const text = {
  sectionTitle: 'Garden preferences',
  hemisphereTitle: 'Hemisphere',
  hemisphereDescription:
    'Select your hemisphere to show appropriate planting months in the sowing calendar and other features.',
  hemisphereLabel: 'Hemisphere',
  hemispherePlaceholder: 'Select hemisphere',
  hemisphereSouthern: 'Southern Hemisphere (e.g., Australia, New Zealand)',
  hemisphereNorthern: 'Northern Hemisphere (e.g., USA, Europe)',
  regionTitle: 'Climate zone',
  regionDescription:
    'Select your climate zone to get accurate sowing recommendations. If a plant is not suitable for your zone, it will be marked as not suitable.',
  regionLabel: 'Climate zone',
  regionPlaceholder: 'Select climate zone',
  regionCool: 'Cool',
  regionTemperate: 'Temperate',
  regionSubtropical: 'Subtropical',
  regionTropical: 'Tropical',
  seedBufferTitle: 'Seed buffer',
  seedBufferDescription:
    'Set the default buffer percentage for seed calculations in the seed planner. This adds extra seeds to account for germination failures or losses.',
  seedBufferLabel: 'Default seed buffer (%)',
  seedBufferHint: 'Recommended: 5–10% for most seeds',
  seedBufferExtra: (percent: number) => `${percent}% extra seeds`,
  saveChanges: 'Save changes',
  reset: 'Reset',
  saveSuccess: 'Settings saved successfully!',
  saveError: 'Error saving settings. Please try again.',
};
